import React, { createContext, useState, useContext, useEffect } from 'react';
import Cookies from "js-cookie";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return Cookies.get('isAuthenticated') === 'true';
  });

  useEffect(() => {
    Cookies.set('isAuthenticated', isAuthenticated, { expires: 7 }); // Set the cookie to expire in 7 days
  }, [isAuthenticated]);


  const login = () => {
    setIsAuthenticated(true)
  };
  

  const logout = () => {
    return new Promise((resolve) => {
      setIsAuthenticated(false);
      resolve();
    });
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
